module.exports = __webpack_public_path__ + "static/media/the-wasteful-fate-of-a-third-of-food.b6f0e585.jpg";